import { render, staticRenderFns } from "./editar-sucursal.vue?vue&type=template&id=5dc21c28&"
import script from "./editar-sucursal.vue?vue&type=script&lang=js&"
export * from "./editar-sucursal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports